var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObjectBucketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28125 7.03125H3.01667C3.37311 3.09478 6.69102 0 10.7188 0H13.5312C17.559 0 20.8769 3.09478 21.2333 7.03125H21.9688C22.3571 7.03125 22.6719 7.34606 22.6719 7.73438V9.14062C22.6719 9.52894 22.3571 9.84375 21.9688 9.84375H2.28125C1.89294 9.84375 1.57812 9.52894 1.57812 9.14062V7.73438C1.57812 7.34606 1.89294 7.03125 2.28125 7.03125ZM13.5312 1.40625H10.7188C7.46708 1.40625 4.78081 3.87164 4.42991 7.03125H19.8201C19.4692 3.87164 16.7829 1.40625 13.5312 1.40625Z",
    fill: "#EA4903"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4366 23.4483C18.3655 23.7705 18.08 24 17.75 24H6.5C6.17005 24 5.88449 23.7705 5.81338 23.4483L3.12257 11.25H21.1274L18.4366 23.4483Z",
    fill: "#EA4903"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectBucketIcon);
export default __webpack_public_path__ + "static/media/object-bucket-icon.6cd4a9361e8c839fbb5ef98ae5d7da6c.svg";
export { ForwardRef as ReactComponent };